import { DEFAULT_PAGINATION } from '../../constants/pagination';
import { IApplicationState } from '../../types/redux';

export function getPagination(state: IApplicationState) {
  if (state.buildersList) {
    const {
      page = DEFAULT_PAGINATION.page,
      limit = DEFAULT_PAGINATION.limit,
      total = DEFAULT_PAGINATION.total,
    } = state.buildersList;

    return { page, limit, total };
  }

  return DEFAULT_PAGINATION;
}
